import React from 'react';

import { ButtonV3 } from '@zola/zola-ui/src/components/ButtonV3';

import { Container, Title, Subtitle } from './PLPNoResults.styles';

export type PLPNoResultsProps = {
  clearFilters: () => void;
};

const PLPNoResults = ({ clearFilters }: PLPNoResultsProps): JSX.Element => (
  <Container data-testid="PLPNoResults">
    <Title>
      Hm... we couldn&apos;t find any designs that match what you&apos;re searching for.
    </Title>
    <Subtitle>Try clearing your filters to find what you&apos;re looking for.</Subtitle>
    <ButtonV3 onClick={clearFilters}>Clear all filters</ButtonV3>
  </Container>
);

export default PLPNoResults;
